import { Card, CardContent, CardHeader, Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

import { useAppVersion, whatsNewHref } from "../../lib/appVersion.js";

/**
 * Profile ▸ "About this app" — the desktop-only surface for the post-upgrade
 * "what's new" deep-link (no popup; just a link, per the chosen UX).
 *
 * Shows the running desktop version and, when the app was recently updated,
 * a link straight into the Change Log scoped to everything shipped across
 * the stack since the user's previous version. Renders nothing on the web
 * (no app version there) so it never appears for browser users.
 */
export function AboutCard(): JSX.Element | null {
  const info = useAppVersion();
  if (!info.currentVersion) return null; // desktop app only

  const href = whatsNewHref(info);
  return (
    <Card>
      <CardHeader title="About this app" />
      <CardContent sx={{ display: "grid", gap: 1 }}>
        <Typography sx={{ fontSize: 14, color: "text.secondary" }}>
          Desktop app version{" "}
          <Typography component="span" sx={{ fontWeight: 600, color: "text.primary" }}>
            {info.currentVersion}
          </Typography>
        </Typography>
        <Link component={RouterLink} to={href} sx={{ fontSize: 14, width: "fit-content" }}>
          {info.upgradedFrom
            ? `See what's new since v${info.upgradedFrom}`
            : "View the change log"}
        </Link>
      </CardContent>
    </Card>
  );
}
